/** Energy bills /metering/bill/consumption-bill (consumptionBill.vue) */
export default {
  consumptionBillPage: {
    phDateStart: 'Start date',
    phDateEnd: 'End date',
    phTenant: 'Tenant name / ID',
    phTenantType: 'Tenant type',
    tenantType0: 'Tenant',
    tenantType1: 'Common area',
    tenantType2: 'Other',
    tenantType3: 'Solar',
    phBillType: 'Charge type',
    phSettleWay: 'Bill type',
    phPayType: 'Payment mode',
    billTypeElectric: 'Electricity',
    billTypeWater: 'Water',
    billTypeService: 'Service fee',
    settleWay0: 'Standard settlement',
    settleWay2: 'System adjustment',
    optPayPrepaid: 'Prepaid',
    optPayPostpaid: 'Postpaid',
    btnSearch: 'Search',
    btnReset: 'Reset',
    btnExport: 'Export',
    exportCurrentPage: 'Export current page',
    exportSelected: 'Export selected',
    exportAll: 'Export all',
    btnExpand: 'Expand',
    btnCollapse: 'Collapse',
    tooltipMeterElec: 'Metered electricity:',
    tooltipOtherElec: 'Other electricity:',
    tooltipMeterWater: 'Metered water:',
    tooltipOtherWater: 'Other water:',
    tooltipTotal: 'Total:',
    statMeterElectricity: 'Metered electricity',
    statMeterWater: 'Metered water',
    statServiceFee: 'Service fee',
    statGrandTotal: 'Total',
    sectionTitle: 'Energy bills',
    sortDefault: 'Default sort',
    selectedLine: '<span class="count">{count}</span> row(s) selected',
    payPaid: 'Paid',
    payUnpaid: 'Unpaid',
    colAction: 'Actions',
    btnDetail: 'Details',
    shortcut7d: 'Last 7 days',
    shortcut15d: 'Last 15 days',
    shortcut30d: 'Last 30 days',
    shortcutThisMonth: 'This month',
    shortcutLastMonth: 'Last month',
    colRid: 'Bill no.',
    colOccurDate: 'Bill date',
    colCreateTime: 'Created',
    colTenantInfo: 'Tenant',
    colPayType: 'Payment mode',
    colBillType: 'Charge type',
    colSettleWay: 'Bill type',
    colBalance: 'Amount',
    colPayStatus: 'Payment',
    colDiscountAmt: 'Credit paid (¥)',
    colRealAmt: 'Cash paid (¥)',
    colStatus: 'Invoice status',
    invoice0: 'Not invoiced',
    invoice1: 'Pending review',
    invoice2: 'Invoiced',
    invoice3: 'Rejected',
    msgFetchListFail: 'Failed to load data',
    msgFetchBillFail: 'Failed to load bills',
    msgNoDataExport: 'No data to export',
    msgExportFail: 'Export failed. Please try again.',
    msgExportOk: 'Exported {count} row(s).',
    msgExportOkSelected: 'Exported {count} selected row(s).',
    warnNoSelectedExport: 'Please select rows to export',
    successExported: 'Exported {count} row(s)',
    successExportedLimit: '{total} row(s) in total, first {count} row(s) exported',
    exporting: 'Exporting...',
    exportSheetName: 'Energy bills',
    filePrefix: 'EnergyBill',
    billTypeUseWater: 'Water',
    billTypeUseElectric: 'Electricity',
    billTypeUseService: 'Service fee'
  }
}
